import React from "react";

function SidebarItem({ icon, iconImage, text, active = false, isCompositeIcon = false }) {
	const renderIcon = () => {
		if (isCompositeIcon) {
			return (
				<span className="sidebar-icon-composite" aria-hidden="true">
					<i className="fa fa-horse" />
					<i className="fa fa-plus sidebar-icon-composite__plus" />
				</span>
			);
		}

		if (iconImage) {
			return <img className="sidebar__brand-icon" src={iconImage} alt="" aria-hidden="true" />;
		}

		return <i className={icon} aria-hidden="true" />;
	};

	return (
		<span className={`sidebar__item${active ? " sidebar__item--active" : ""}`}>
			<span className="sidebar__item-icon">{renderIcon()}</span>
			<span className="sidebar__item-label">{text}</span>
		</span>
	);
}

export default SidebarItem;
